import { tv } from '~/utils/tv'

export const SnackbarTimebarVariants = tv({
  base: `
     max-h-onepulse px-0.5
  `,
})
